module.exports = __webpack_public_path__ + "img/Goalpilot_logo_white_500.f2961f00.png";